import React, { useMemo, useState } from "react";
import { faEllipsis, faTrashAlt } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "../../button/Button";
import "./SourceActionsMenu.scss";
import { useTranslation } from "react-i18next";
import { NetworkStaticRouteConfig } from "userful-chronos-app-common-js/dist/models/config/networkConnections";
import { StringID } from "userful-chronos-app-common-js/dist/models/common";
import DeleteRoutes from "../../ConfirmationDialog/Template/DeleteRoutes";
import Dropdown from "../../dropdown/Dropdown";
import { IDropdownItem } from "../../dropdown/dropdownUtils";

interface IProps {
    value: NetworkStaticRouteConfig;
    connectionUUID: StringID;
    onEdit: (connections: NetworkStaticRouteConfig) => void;
    onDelete: (connections: NetworkStaticRouteConfig) => void;
}

export default function NetworkRoutesMenu(props: IProps) {
    const { t } = useTranslation();
    const [deleteOpen, setDeleteOpen] = useState(false);

    const dropdownItems: IDropdownItem[] = useMemo(
        () => [{ id: "delete", icon: <FontAwesomeIcon icon={faTrashAlt} />, title: "Shared.delete" }],
        [],
    );

    const handleDropdownChange = (item: IDropdownItem) => {
        if (item.id === "delete") {
            setDeleteOpen(true);
        }
    };

    return (
        <div onClick={(event) => event.stopPropagation()}>
            <Dropdown
                items={dropdownItems}
                onChange={handleDropdownChange}
                trigger={
                    <Button
                        className="source-actions-menu-toggle"
                        variant="ghost"
                        size="small"
                        iconOnly
                        aria-label={t("Shared.actions")}
                    >
                        <FontAwesomeIcon icon={faEllipsis} />
                    </Button>
                }
                usePortal
            />
            <DeleteRoutes
                routes={[props.value]}
                connectionUUID={props.connectionUUID}
                type={"dropdown"}
                onDelete={() => {
                    props.onDelete(props.value);
                }}
                open={deleteOpen}
                onOpenChange={setDeleteOpen}
                hideTrigger
            />
        </div>
    );
}
